import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { getServerTime, sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { getSpaTreatmentList } from "../../../action/spaBooking";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { cssNumber } from "jquery";
import { getMySpaBooking } from "../../../action/spaBooking";
import { formatLocalTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import SpaBookingCancelPopUp from "./spaBookingCancelPopUp";
import SpaBookingUpdatePopUp from "./spaBookingUpdatePopUp";

import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";

 

export const formatTime = (time, timeFormat12hrs) => {
  let [hours,minutes] = time.split(":");

  let suffix = '';

  if (timeFormat12hrs) {
      suffix = hours >= 12 ? ' PM' : ' AM';
      hours = hours % 12 || 12;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${suffix}`;
}

 

const SpaBooking2a = (props) => {
  const [isfetchingReservation, setIsfetchingReservation] = useState(false);
  const [myExistingReservation, setMyExistingReservation] = useState([]);

  const [cancelReservationDetails, setCancelReservationDetails] = useState(null);
  const [showCancelReservation, setShowCancelReservation] = useState(false);
  const [showUpdateReservationPopup, setShowUpdateReservationPopup] = useState(false);
  const [updateReservationDetails, setUpdateReservationDetails] = useState(null);

  let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");
  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  const cachedMyReservationsKey= `my_reservations_${props.spaLocationId}`;

  const { t } = props;



  const formatDate = (dateString) => {
    console.log(dateString, "dateString");
    const reservationDate= dateString.split('T')[0];
    const todayDate = props.serverTimeDate.split("T")[0];

    if( moment(todayDate).format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY') ){
      return "Today";
    } else if ( moment(todayDate).subtract(1,'days').format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY')) {
      return "Yesterday";
    } else if ( moment(todayDate).add(1,'days').format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY')) {
      return "Tomorrow";
    } else {
      return `${moment(dateString).format(props.dateFormat.toUpperCase())}`
    }
  };

  const groupingByDate = (data) => {
    const groupedAccToDay = new Map();

    data.sort((a, b) => {
      return (
        new Date(a.date).getTime() -
        new Date(b.date).getTime()
      );
    });
    console.log(data);
    data.forEach((d) => {
      const groupingKey = formatDate(d.date);
      if (groupedAccToDay.has(groupingKey)) {
        const keyData = groupedAccToDay.get(groupingKey);
        keyData.push(d);
      } else {
        groupedAccToDay.set(groupingKey, [d]);
      }
    });

    console.log(groupedAccToDay, "groupedAccToDay");
    return groupedAccToDay;
  };



  function getSpaDetails() {
    console.log(props, "props,in 2a");
    const spa = props.spaData.find(
      (data) => data.spalocationId == props.spaLocationId
    );
    console.log(spa);
    return spa;
  }

  const handleDeleteReservation = (bool, msg) => {

  setShowCancelReservation(false);
  setCancelReservationDetails(null)
  let cachedData = props.cachedApiDataStore;
  delete cachedData[`my_reservations_${props.spaLocationId}`];
  props.setCachedApiDataStore(cachedData);

  if (bool) {
    props.closeOrderPopUp(true, t('spaBooking.success.successful_res_cancelled'), "", false)
  }
  else {
    console.log('would show closeorderpopup now')
    props.closeOrderPopUp(true, msg || t('spaBooking.failure.fail_res_cancelled'), "", true)
  }
  getExistingReservations();


}


  const handleSuccessfulFetch = (allReservations) => {

    let spaReservations = allReservations.filter((r) => r.type == "spa");

    if (spaReservations.length > 0) {

      props.setIsAnyPrevReservForAnyLocation(true);
    } else {
      props.setIsAnyPrevReservForAnyLocation(false);

    }





    // get all locations possible
    // for spa , do save key per location
    let locationWiseReservations ={};

    props.spaData.forEach((data)=>{
      locationWiseReservations[`my_reservations_${data.spalocationId}`]=[];
    })


    spaReservations.forEach((reservation) => {
      const key = `my_reservations_${reservation.locationId}`
      if (locationWiseReservations.hasOwnProperty(key)) {
        locationWiseReservations[key] = [...locationWiseReservations[key], reservation];
      }
      else {
        locationWiseReservations[key] = [reservation]
      }
    })

    props.setCachedApiDataStore(locationWiseReservations)



    const reservationsParticularToSpaLocation = spaReservations.filter(d => { return d.locationId == props.spaLocationId })



    setMyExistingReservation(reservationsParticularToSpaLocation);

  }


  const shouldDisappearCancelButtonBasedOnCurrentTime =  (reservationDetails) => {

    const currentTime = props.serverDate.date.replace("Z","");
    let reservationTime = reservationDetails.date;

    const currentTimeMiliSeconds = new Date(currentTime).getTime();
    const reservationTimeMiliSeconds = new Date(reservationTime).getTime();
        
    const hoursCancelButtonDisappearBefore =  t("spaBooking.hoursCancelButtonDisappearBefore", { defaultValue:2 })
    console.log(hoursCancelButtonDisappearBefore, "hoursCancelButtonDisappearBefore");
    
    return !( (reservationTimeMiliSeconds - currentTimeMiliSeconds) > (hoursCancelButtonDisappearBefore * 60 * 60 * 1000));
  }


  const fetchMyExistingReservation = () => {
    setIsfetchingReservation(true);
    let payload = {};
    // if (props.spaLocationId) {
    //   payload['spaLocationId'] = props.spaLocationId;
    // }

    // setMyExistingReservation(fake_res.payload.data)
    // setIsfetchingReservation(false);



    getMySpaBooking(payload)
      .then((res) => {
         
        if ((res.status == 200) && ((res && res.data && res.data.header && res.data.header.status && res.data.header.status.code) == "SUCCESS") ){
          let reservations = (res && res.data && res.data.payload && res.data.payload.data);
       
         
         
          handleSuccessfulFetch(reservations)

          // if (props.spaLocationId) {
          //   const reservationsParticularToSpaLocation = res.data.payload.data.filter(d => { return d.locationId == props.spaLocationId })
          //   reservations = reservationsParticularToSpaLocation;
          // }
          // reservations = reservations.filter((r) => r.type == "spa");
           


          // setMyExistingReservation(reservations);


          
          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA MY RESERVATION - SUCCESS",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
            },
            0,
            props.guestIsLoggedIn
          );
        }else{
          props.closeOrderPopUp(true,
            res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg || t("spaBooking.errors.error"),
            "", true);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA MY RESERVATION - ERROR",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
              errorStatus: (res && res.response)?res.response.status:"",
              errorMessage: JSON.stringify(
                res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg
              ),
            },
            0,
            props.guestIsLoggedIn
          );
        }
      })
      .catch((err) => {
        props.closeOrderPopUp(true, t("spaBooking.errors.error"), "", true);
      })
      .finally(() => {
        setIsfetchingReservation(false);
      });



  };

  const getExistingReservations=()=>{
    if (props.cachedApiDataStore && props.cachedApiDataStore.hasOwnProperty(`my_reservations_${props.spaLocationId}`)) {
      setMyExistingReservation(props.cachedApiDataStore[`my_reservations_${props.spaLocationId}`])
    }
    else {
      fetchMyExistingReservation();
    }

  }
  useEffect(() => {
    console.log("getExistingReservations")
    scrollToTop();
    getExistingReservations()

    props.getServerTime((status, payload)=>{})
  }, []);

  useEffect(()=>{
    console.log("my existing reversatin locaions");
    for(const res of myExistingReservation){
      console.log(res.locationId)
    }

  },[myExistingReservation])

  // useEffect(() => {
  //   if (myExistingReservation.length > 0) {
  //     props.setIsAnyPreviousReservation(true);
  //   }
  //   else {
  //     props.setIsAnyPreviousReservation(false)
  //   }
  // }, [myExistingReservation])

  return (
    <section className="widgets padding-0 margin-0 container-bg">

      <section class="widgets spa-listing spa-details">



        {!showUpdateReservationPopup &&
          <>
            <div class="widget-header">
              {props.currentWidgetObj.widgetHeaderImageUrl && (
                <div class="widget-header-img">
                  <img
                    src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                    alt={props.currentWidgetObj.displayName}
                  />
                </div>
              )}
              <div class="widget-header-title">{getSpaDetails().spaName}</div>
              <div class="widget-header-subtitle">
                {getSpaDetails().spaDescription }
              </div>
            </div>

           <div class="row">
              <div class="form-controls">
                <button class="make_a_reservation" onClick={props.next}>
                  {t("spaBooking.make_a_reservation")}
                </button>
              </div>
            </div>  
 
            <div class="widgets">
              <div class="gallery-slides itinerary-list">
                <div class="form-row-heading">
                  {`${t("spaBooking.myReservation")}${myExistingReservation.length > 0 ? "s" : ""
                    }`}
                </div>

                {isfetchingReservation ? (
                  <MiniLoader />
                ) : myExistingReservation.length > 0 ? (
                  <>
                    {Array.from(
                      groupingByDate(myExistingReservation).entries()
                    ).map(([day, dataOnThatDay]) => {
                      return (
                        <div class="list-items-container">
                          <div class="list-item-heading">{day}</div>
                          {dataOnThatDay.map((reservation) => {
                            return (
                              <div class="list-item">
                                <div class="list-item-contents">
                                  <div class="list-item-name">{reservation.lines[0].serviceName}</div>

                                  <div class="list-item-body">
                                    {formatTime(
                                      reservation.date.split('T')[1],
                                      toBool(props.timeFormat)
                                    )}
                                  </div>
                                </div>

                                <div class="list-item-opt">
                                  {reservation.cancelled ? (
                                    <span class="status-cancelled">
                                      {'cancelled'}
                                    </span>
                                  ) : (
                                    <>
                                      <button
                                        onClick={() => {
                                          setShowUpdateReservationPopup(true);
                                          setUpdateReservationDetails(reservation)
                                        }}
                                      >
                                        <i className="fas fa-pen"></i>
                                      </button>

                                      {
                                         props.serverDate && shouldDisappearCancelButtonBasedOnCurrentTime(reservation) ?
                                          <></>
                                         :
                                            <button
                                            onClick={() => {
                                              console.log("apponitmentId for cancellationg", reservation.id)
                                              setCancelReservationDetails(reservation);
                                              setShowCancelReservation(true);
                                            }}
                                          >
                                            <i className="fas fa-times"></i>
                                          </button>
                                      }
                                    </>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="no_reservation">
                      {((props.cachedApiDataStore && props.cachedApiDataStore.hasOwnProperty(`my_reservations_${props.spaLocationId}`))) ? t("spaBooking.no_reservation_found") : t("spaBooking.errors.error")}
                  </div>
                )}
              </div>
            </div>

             {/* <div class="row">
              <div class="form-controls">
                <button onClick={props.next}>
                  {t("spaBooking.make_a_reservation")}
                </button>
              </div>
            </div>   */}

            {showCancelReservation && (
              <SpaBookingCancelPopUp
                cancelReservationDetails={cancelReservationDetails}
                // appointmentId={cancelAppointmentId}
                spaLocationId={props.spaLocationId}
                handleDeleteReservation={handleDeleteReservation}
                close={() => {
                  setCancelReservationDetails(null);
                  setShowCancelReservation(false);
                }}
              />
            )}

          </>

        }

        {showUpdateReservationPopup && (
          <SpaBookingUpdatePopUp
            updateReservationDetails={updateReservationDetails}
            update={async () => {
              // setShowUpdateReservationPopup(false);
              await props.updateReservation(updateReservationDetails)
            }}
            deprecatedAddonList={props.deprecatedAddonList}
            showDeprecatedAddonWarning={props.showDeprecatedAddonWarning}
            shouldProceedOnDeprecatedAddonsWarning={props.shouldProceedOnDeprecatedAddonsWarning}


            back={() => {
              setUpdateReservationDetails(null);
              setShowUpdateReservationPopup(false);
            }}
          />
        )}
      </section>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,


  };
};

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics, getServerTime })(
  withTranslation("translations")(SpaBooking2a)
);
